import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";

function Sidebar({ links, isOpen, onClose }) {
  const location = useLocation();
  const [openGroups, setOpenGroups] = useState({});

  const isChildActive = (child) => {
    if (!child?.url) {
      return false;
    }
    if (child.url === "/") {
      return location.pathname === "/" || location.pathname === "";
    }
    return (
      location.pathname.toLowerCase() === child.url.toLowerCase() ||
      location.pathname.toLowerCase().startsWith(child.url.toLowerCase() + "/")
    );
  };

  useEffect(() => {
    if (onClose) {
      onClose();
    }
    // Chiude il menu mobile al cambio pagina
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    const groups = {};
    (links || []).forEach((linkObb) => {
      if (linkObb.children) {
        groups[linkObb.testo] = linkObb.children.some((child) =>
          isChildActive(child)
        );
      }
    });
    setOpenGroups((prev) => ({ ...prev, ...groups }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, links]);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === "Escape" && isOpen && onClose) {
        onClose();
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [isOpen, onClose]);

  const toggleGroup = (groupName) => {
    setOpenGroups((prev) => ({
      ...prev,
      [groupName]: !prev[groupName],
    }));
  };

  return (
    <>
      <div
        className={`app-sidebar-overlay${isOpen ? " is-open" : ""}`}
        onClick={onClose}
        aria-hidden="true"
      />
      <aside
        id="app-sidebar"
        className={`app-sidebar${isOpen ? " is-open" : ""}`}
        aria-label="Menu di navigazione"
      >
        <div className="app-sidebar-header d-lg-none">
          <span className="app-sidebar-title">Menu</span>
          <button
            type="button"
            className="app-sidebar-close"
            onClick={onClose}
            aria-label="Chiudi menu"
          >
            <svg className="icon icon-sm">
              <use href={`${iconSprite}#it-close`} />
            </svg>
          </button>
        </div>
        <nav>
          <ul className="app-sidebar-nav">
            {links &&
              links.map((linkObb, index) =>
                linkObb.children ? (
                  <li key={`${linkObb.testo}-${index}`}>
                    <button
                      type="button"
                      className={`app-sidebar-link app-sidebar-group-toggle${
                        linkObb.children.some((child) => isChildActive(child))
                          ? " active"
                          : ""
                      }`}
                      onClick={() => toggleGroup(linkObb.testo)}
                      aria-expanded={!!openGroups[linkObb.testo]}
                    >
                      <span>{linkObb.testo}</span>
                      <svg className="icon icon-xs">
                        <use href={`${iconSprite}#it-expand`} />
                      </svg>
                    </button>
                    {openGroups[linkObb.testo] && (
                      <ul className="app-sidebar-subnav">
                        {linkObb.children.map((child, childIndex) => (
                          <li key={`${child.url}-${childIndex}`}>
                            <NavLink
                              to={child.url}
                              className="app-sidebar-link app-sidebar-sublink"
                              activeClassName="active"
                              exact={child.url === "/"}
                            >
                              {child.testo}
                            </NavLink>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ) : (
                  <li key={`${linkObb.url}-${index}`}>
                    <NavLink
                      to={linkObb.url}
                      className="app-sidebar-link"
                      activeClassName="active"
                      exact={linkObb.url === "/"}
                    >
                      {linkObb.testo}
                    </NavLink>
                  </li>
                )
              )}
          </ul>
        </nav>
      </aside>
    </>
  );
}

export default Sidebar;
